// m.place 사진·영업시간 격리 — 단일 소스(문자열).
//
// Hermes 는 Function#toString() 이 원본 소스를 안 돌려줘서
// 함수 본문을 문자열로 두고 RN WebView 에 그대로 inject /
// 웹 하네스에서는 eval 해 호출한다.
//
// 레이아웃은 원래대로 DOM 자리에 두고 prune (display:none !important).
// 노드를 host 로 옮기면 .place_section_content / .PIbes 패딩(16px 등)이
// 사라져 영업시간이 카드 끝에 붙는다 — remount 하지 말 것.
//
// PlaceCard 218px: lazy 영업시간은 waitReady 스크롤+MO 로 확보.
// 네이버 React 가 display 를 되살리면 maintain 이 다시 prune.
//
// 테스트:
//   node web/test-isolate-narrow.mjs
//   node web/test-isolate-30.mjs
//   node web/test-isolate-bench.mjs

const RUN_ISOLATE_NAVER_PLACE_PAGE_SRC = `
function runIsolateNaverPlacePage(win) {
  var document = win.document;
  var Element = win.Element;
  var t0 = Date.now();
  var lockedPhoto = null;
  var lockedHours = null;
  var maintainObserver = null;
  var clickBound = false;

  function bridge(msg) {
    try {
      if (win.ReactNativeWebView && win.ReactNativeWebView.postMessage) {
        win.ReactNativeWebView.postMessage(msg);
      }
    } catch (e) {}
  }

  function elapsed() {
    return Date.now() - t0;
  }

  function isolatePathsByElements(elements, rootElement) {
    if (!rootElement) rootElement = document.body;
    var targets =
      elements instanceof Element ? [elements] : Array.from(elements || []);
    function prune(node) {
      if (targets.includes(node)) return;
      Array.from(node.children).forEach(function (child) {
        var keepBranch = targets.some(function (t) {
          return t && (child === t || child.contains(t));
        });
        if (keepBranch) {
          prune(child);
        } else {
          try {
            child.style.setProperty("display", "none", "important");
          } catch (e) {
            child.style.display = "none";
          }
        }
      });
    }
    prune(rootElement);
  }

  function findPhotoCarousel() {
    var main = document.querySelector('div[role="main"]');
    if (!main) return null;

    var preferred =
      main.querySelector(".qZ2bl") ||
      main.querySelector(".pui__ZDFM2o") ||
      main.querySelector(".pui__-Es8bt");
    if (preferred) {
      var pn = preferred.querySelectorAll("img").length;
      var ph = preferred.getBoundingClientRect().height;
      if (pn >= 1 && ph >= 40 && ph <= 400) return preferred;
    }

    var header = main.firstElementChild || main;
    var best = null;
    var bestScore = -1;
    Array.from(header.querySelectorAll("*")).forEach(function (el) {
      var n = el.querySelectorAll("img").length;
      if (n < 2) return;
      var h = el.getBoundingClientRect().height;
      if (h < 60 || h > 360) return;
      if (/영업|민생회복|지원금|길찾기/.test(el.textContent || "")) return;
      var score = n * 10 - Math.abs(h - 210);
      if (score > bestScore) {
        bestScore = score;
        best = el;
      }
    });
    return best;
  }

  /* 상세 블록만 우선. 헤더 요약은 최후 수단 (타이틀 가지 keep 방지) */
  function findBusinessHour(allowHeaderFallback) {
    var main = document.querySelector('div[role="main"]');
    if (!main) return null;
    var detail = main.querySelector("div.O8qbU.pSavy");
    if (detail && !/민생회복|지원금|고유가/.test(detail.textContent || "")) {
      return detail;
    }
    if (!allowHeaderFallback) return null;
    var status = main.querySelector(".HzOD8.Mwr0n");
    if (status) return status;
    var time = main.querySelector("time");
    if (time) {
      var cur = time;
      var best = time;
      while (cur && cur !== main) {
        if (/주소|지도|내비게이션|거리뷰|메뉴판|민생|지원금/.test(cur.textContent || ""))
          break;
        best = cur;
        cur = cur.parentElement;
      }
      return best;
    }
    return null;
  }

  function bumpScroll(y) {
    var scrolling =
      document.scrollingElement || document.documentElement || document.body;
    try {
      win.scrollTo(0, y);
      if (scrolling) scrolling.scrollTop = y;
    } catch (e) {}
  }

  function hideOutsideMain() {
    var main = document.querySelector('div[role="main"]');
    if (!main) return;
    var node = main;
    while (node && node !== document.body) {
      var parent = node.parentElement;
      if (!parent) break;
      Array.from(parent.children).forEach(function (sib) {
        if (sib === node) return;
        try {
          sib.style.setProperty("display", "none", "important");
        } catch (e) {}
      });
      node = parent;
    }
  }

  /**
   * 원래 PlaceCard isolate 레이아웃:
   * - 노드는 옮기지 않음 (조상 .place_section_content 패딩 16px 등 유지)
   * - 캐러셀 자체 padding 은 건드리지 않음
   * - PHOTO_HEIGHT 150, 조상 minHeight/top margin·padding 만 정리
   * - businessHour 는 marginTop=0 만
   */
  function applyIsolate(isRetry, photoHint, hoursHint) {
    var main = document.querySelector('div[role="main"]');
    if (!main) return { imageHeader: false, businessHour: false };

    var imageHeader =
      (photoHint && document.contains(photoHint) && photoHint) ||
      (lockedPhoto && document.contains(lockedPhoto) && lockedPhoto) ||
      findPhotoCarousel();
    var businessHour =
      (hoursHint && document.contains(hoursHint) && hoursHint) ||
      (lockedHours && document.contains(lockedHours) && lockedHours) ||
      findBusinessHour(true);

    if (imageHeader) lockedPhoto = imageHeader;
    if (businessHour) lockedHours = businessHour;

    isolatePathsByElements(
      [imageHeader, businessHour].filter(Boolean),
      document.body,
    );
    hideOutsideMain();

    ;[imageHeader, businessHour].filter(Boolean).forEach(function (node) {
      for (var a = node.parentElement; a && a !== main; a = a.parentElement) {
        a.style.minHeight = "0";
      }
    });

    if (imageHeader) {
      // 사진 캐러셀 고정 높이 — 이미지 로드와 무관하게 흔들림 방지.
      // WebView 218px 안에 사진+영업시간이 맞게 들어가도록 150 유지 (원래 의도).
      var PHOTO_HEIGHT = 150;
      imageHeader.style.height = PHOTO_HEIGHT + "px";
      Array.from(imageHeader.querySelectorAll("img")).forEach(function (im) {
        im.style.height = PHOTO_HEIGHT + "px";
      });
      imageHeader.style.marginTop = "0";
      for (
        var b = imageHeader.parentElement;
        b && b !== main;
        b = b.parentElement
      ) {
        b.style.marginTop = "0";
        b.style.paddingTop = "0";
      }
    }
    if (businessHour) {
      businessHour.style.marginTop = "0";
    }

    bumpScroll(0);

    if (!isRetry && imageHeader && !clickBound) {
      clickBound = true;
      imageHeader.addEventListener("click", function (event) {
        bridge("clicked");
        event.stopPropagation();
      });
    }

    return { imageHeader: !!imageHeader, businessHour: !!businessHour };
  }

  function waitReady(timeoutMs) {
    if (timeoutMs === undefined) timeoutMs = 5500;
    return new Promise(function (resolve) {
      var start = Date.now();
      var scrollY = 0;
      var scrollStep = 550;
      var maxScroll = 2200;
      var settled = false;
      var observer = null;

      function cleanup() {
        if (settled) return;
        settled = true;
        if (observer) {
          try {
            observer.disconnect();
          } catch (e) {}
        }
      }

      function finish(photo, hours, mode) {
        cleanup();
        bumpScroll(0);
        resolve({ photo: photo, hours: hours, mode: mode });
      }

      function tick() {
        if (settled) return;
        var photo = findPhotoCarousel();
        var hours = findBusinessHour(false);
        if (photo && hours) {
          finish(photo, hours, "detail");
          return;
        }
        var waited = Date.now() - start;
        if (waited >= timeoutMs) {
          hours = findBusinessHour(true);
          finish(photo, hours, hours ? "fallback" : "partial");
          return;
        }
        if (!hours) {
          if (photo) {
            scrollY = Math.min(maxScroll, scrollY + scrollStep);
          } else {
            scrollY = Math.min(400, scrollY + 200);
          }
          bumpScroll(scrollY);
        }
        setTimeout(tick, 40);
      }

      try {
        observer = new MutationObserver(function () {
          if (settled) return;
          var photo = findPhotoCarousel();
          var hours = findBusinessHour(false);
          if (photo && hours) finish(photo, hours, "detail-mo");
        });
        observer.observe(document.documentElement || document.body, {
          childList: true,
          subtree: true,
        });
      } catch (e) {
        observer = null;
      }

      tick();
    });
  }

  function removeFixedSpacerOnScroll() {
    var timer;
    function onScroll() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var el = document.querySelector('div[style="height: 48px;"]');
        if (el) {
          el.remove();
          win.removeEventListener("scroll", onScroll);
        }
      }, 100);
    }
    win.addEventListener("scroll", onScroll);
  }

  function startMaintain() {
    if (maintainObserver) return;
    try {
      maintainObserver = new MutationObserver(function () {
        applyIsolate(true, lockedPhoto, lockedHours);
      });
      maintainObserver.observe(document.documentElement || document.body, {
        childList: true,
        subtree: true,
      });
    } catch (e) {
      maintainObserver = null;
    }
    setTimeout(function () {
      if (maintainObserver) {
        try {
          maintainObserver.disconnect();
        } catch (e) {}
        maintainObserver = null;
      }
      applyIsolate(true, lockedPhoto, lockedHours);
    }, 2500);
  }

  function schedulePostDoneRetries() {
    var interval = 50;
    var remaining = 400;
    function step() {
      applyIsolate(true, lockedPhoto, lockedHours);
      remaining -= interval;
      if (remaining > 0) setTimeout(step, interval);
    }
    setTimeout(step, interval);
  }

  bridge("isolate:start");
  return waitReady(5500)
    .then(function (ready) {
      lockedPhoto = ready && ready.photo;
      lockedHours = ready && ready.hours;
      bridge(
        "isolate:ready mode=" +
          (ready && ready.mode) +
          " ms=" +
          elapsed()
      );
      var r = applyIsolate(false, lockedPhoto, lockedHours);
      bridge(
        "isolate:kept img=" +
          (r && r.imageHeader ? "1" : "0") +
          " hours=" +
          (r && r.businessHour ? "1" : "0") +
          " ms=" +
          elapsed()
      );
      removeFixedSpacerOnScroll();
      if (
        document.body &&
        document.body.textContent.indexOf(
          "페이지의 주소가 변경 혹은 삭제되어 요청하신 페이지를 찾을 수 없습니다"
        ) !== -1
      ) {
        bridge("page_deleted");
      }
      bridge("done");
      bridge("isolate:timing:" + elapsed());
      startMaintain();
      schedulePostDoneRetries();
    })
    .catch(function (e) {
      bridge("isolate:error:" + (e && e.message ? e.message : String(e)));
      bridge("done");
      bridge("isolate:timing:" + elapsed());
    });
}
`

const isolateNaverPlacePageInjectScript =
  '(' + RUN_ISOLATE_NAVER_PLACE_PAGE_SRC + ')(window);'

function runIsolateNaverPlacePage(win) {
  const fn = (0, eval)('(' + RUN_ISOLATE_NAVER_PLACE_PAGE_SRC + ')')
  return fn(win)
}

module.exports = {
  runIsolateNaverPlacePage,
  isolateNaverPlacePageInjectScript,
  RUN_ISOLATE_NAVER_PLACE_PAGE_SRC,
}
